import React, { useState, useEffect, useRef } from "react";

const productsData = [
  {
    id: 1,
    title: "LPG Retailing Service",
    description: `Our retail outlet provides access to liquefied petroleum gas (LPG) to meet the needs of households in the host community as an alternative to biomass fuels.
`,
    image: "/images/retailing.jpg",
  },
  {
    id: 2,
    title: "Waste-to-Fuel Mechanism",
    description: `This initiative receives recyclables as an alternative payment for LPG, helping us reduce energy costs by up to 30% for households. It allows households to exchange recyclable waste such as Pure Water Sachet, Plastic Bottles, and Beverage Cans for point rewards, redeemable for LPG at our LPG sales point. 
`,
    image: "/images/wastetofuel.jpg",
  },
  {
    id: 3,
    title: "Guerate Accessory Exchange (GAE):",
    description: `This is the LPG accessories hybrid scheme. It provides access to essential accessories for LPG stoves and cylinders through a micro-finance model. GAE allow household to own gas cylinders and accessories with little instalment. The balance is payed overtime with the Waste-to-fuel point reward. GAE is established and integrated with the Waste-to-fuel mechanism to help enhance affordability and reduce financial barriers to clean energy adoption.
`,
    image: "/images/cylinderexchange.jpg",
  },
];

const ProductsAndServices = React.forwardRef((props, ref) => {
  const [readMore, setReadMore] = useState({});
  const cardRefs = useRef([]);

  const toggleReadMore = (id) => {
    setReadMore((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const highlightGuerateEnergy = (text) => {
    const parts = text.split(/(Guerate Energy)/gi);
    return parts.map((part, index) =>
      part.match(/guerate energy/i) ? (
        <span key={index} className="text-green-600 font-semibold">
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  useEffect(() => {
    // Set all cards to the same height initially
    const heights = cardRefs.current.map(
      (ref) => ref.getBoundingClientRect().height
    );
    const maxHeight = Math.max(...heights);
    cardRefs.current.forEach((ref) => {
      ref.style.height = `${maxHeight}px`;
    });
  }, []);

  return (
    <div ref={ref} className="bg-[#f9f9f9] py-7">
      <div className="w-[90%] flex flex-col gap-7 mx-auto">
        <h1 className="text-4xl md:text-6xl text-[#f46524]">Our Solution</h1>

        <div className="grid lg:grid-cols-3 gap-4">
          {productsData.map((product, index) => (
            <div
              key={product.id}
              className={`flex flex-col gap-4 shadow-2xl cursor-pointer hover:shadow-sm p-4 h-fit`}
              ref={(el) => (cardRefs.current[index] = el)}
              style={readMore[product.id] ? { height: "auto" } : {}}
            >
              <img
                src={product.image}
                alt={product.title}
                className="w-full h-48 object-cover"
              />
              <h2 className="text-xl font-semibold">{product.title}</h2>
              <p>
                {readMore[product.id] ? (
                  <>{highlightGuerateEnergy(product.description)}</>
                ) : (
                  <>
                    {highlightGuerateEnergy(
                      product.description.substring(0, 100)
                    )}
                    ...
                  </>
                )}
                <button
                  onClick={() => toggleReadMore(product.id)}
                  className="text-blue-500 ml-2"
                >
                  {readMore[product.id] ? "Read Less" : "Read More"}
                </button>
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

export default ProductsAndServices;
